import React from 'react';

import { ClickableItem, StyledLink } from './SelectableOption.styles';
import { ListItem, ListItemProps } from './molecules/ListItem/ListItem';

export type SelectableOptionProps = ListItemProps & {
  onClick?: () => void;
  linkTo?: string;
};

export const SelectableOption: React.FC<SelectableOptionProps> = ({ linkTo, onClick, ...rest }) => {
  if (onClick) {
    return (
      <ClickableItem onClick={onClick} data-testid="selectable-option">
        <ListItem {...rest} />
      </ClickableItem>
    );
  }

  if (linkTo) {
    return (
      <StyledLink to={linkTo} data-testid="selectable-option">
        <ListItem {...rest} />
      </StyledLink>
    );
  }

  return null;
};
